import PropTypes from 'prop-types';
import React, { useCallback, useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-react/wizard';
import {
  makeStyles,
  Caption1Strong,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
} from '@fluentui/react-components';
import { selectedCampaignsAccordionStyles } from '../../page-layout';
import { CampaignNameTag } from './campaign-name-tag';

const useStyles = makeStyles(selectedCampaignsAccordionStyles);

export const SelectedCampaignsAccordion = ({ onRemoveCampaign, selectedCampaigns }) => {
  const styles = useStyles();
  const i18n = useContext(I18nContext);

  const selectedCampaignsHeader = i18n.getString(_TL_('Campaigns'));

  const numCampaigns = useMemo(() => selectedCampaigns.length, [selectedCampaigns]);

  const { state: wizardState, send } = useWizardService();
  const removeCampaign = useCallback((id) => {
    const { selectedCampaignsById } = wizardState.context.wizardData;
    delete selectedCampaignsById[id];
    send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, { selectedCampaignsById });
    onRemoveCampaign({ count: Object.keys(selectedCampaignsById).length });
  }, [onRemoveCampaign, send, wizardState.context.wizardData]);

  return (
    <Accordion collapsible defaultOpenItems="1">
      <AccordionItem value="1">
        <AccordionHeader size="small" className={styles.accordionHeader}>
          <Caption1Strong className={styles.accordionHeaderText}>{selectedCampaignsHeader}</Caption1Strong>
          <span className={styles.count}>{numCampaigns} {i18n.getString(_TL_('campaigns'))}</span>
        </AccordionHeader>
        <AccordionPanel>
          <div className={styles.tagsList}>
            {selectedCampaigns.map(campaign => (
              <CampaignNameTag campaign={campaign} onRemove={removeCampaign} key={campaign.Id} />
            ))}
          </div>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

SelectedCampaignsAccordion.propTypes = {
  onRemoveCampaign: PropTypes.func.isRequired,
  selectedCampaigns: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  })).isRequired,
};
